import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'section',
		'input',
	]

	connect() {
		if (!this.hasInputTarget || !this.hasSectionTarget) return

		for (const input of this.inputTargets) {
			for (const target of this.sectionTargets) {
				this.updateTarget(target, input.name, input.value)
			}
		}
	}

	update(event) {
		if (!this.hasSectionTarget) return

		for (const target of this.sectionTargets) {
			this.updateTarget(target, event.currentTarget.name, event.currentTarget.value)
		}
	}

	updateTarget(targetElement, inputName, inputValue) {
		if (!targetElement || !inputName || !inputValue) return

		const matchOnName  = targetElement.dataset.ifInputName
		const matchOnValue = targetElement.dataset.ifInputValue

		if (inputName == matchOnName && inputValue == matchOnValue) {
			targetElement.classList.remove('d-none')
		} else {
			targetElement.classList.add('d-none')
		}
	}

}
